import enLocale from './en.json';

export const LocaleFiles = {
  en: enLocale,
};
